import React, { useEffect, useState } from "react"
import { getStatusFinalJasmed } from "./helpers"
import { HighlightOff, VerifiedUser } from "@material-ui/icons"
import { defaultDateDisplay } from "App/utils/helpers"
import { Tooltip } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

export default function ButtonFinalJasmed({ formData, setFormData }) {
  const [isLoading, setIsLoading] = useState(false)
  const [rows, setRows] = useState({ final_tagihan: null })

  const setNewData = async () => {
    setIsLoading(true)
    const res = await getStatusFinalJasmed(formData.tagihan_id)

    setIsLoading(false)
    if (res.state) {
      setRows({
        ...rows,
        final_tagihan: res.data?.body,
      })
    } else {
      setRows({
        ...rows,
        final_tagihan: null,
      })
    }
  }

  useEffect(() => {
    if (formData.tagihan_id) {
      setNewData()
    }
  }, [formData.reload_final_jasmed, formData.tagihan_id])

  if (rows.final_tagihan?.is_final_tagihan !== null) {
    return (
      <>
        {isLoading && <Skeleton width={50} />}
        {!isLoading && (
          <div
            style={{
              display: "flex",
              fontSize: "12px",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {rows.final_tagihan?.is_final_tagihan ? (
              <VerifiedUser
                style={{
                  color: "green",
                }}
              />
            ) : (
              <HighlightOff
                style={{
                  color: "red",
                }}
              />
            )}
            {rows.final_tagihan?.is_final_tagihan ? (
              <Tooltip title="Final Jasmed">
                <p
                  style={{
                    color: "",
                    fontWeight: "400",
                  }}
                >
                  {defaultDateDisplay(
                    rows.final_tagihan?.tanggal_final_tagihan,
                  )}
                </p>
              </Tooltip>
            ) : (
              <p
                style={{
                  fontWeight: "400",
                }}
              >
                Final Front Office
              </p>
            )}
          </div>
        )}
      </>
    )
  } else {
    return <></>
  }
}
